module.exports = __webpack_public_path__ + "static/media/bg-piloto.909807b3.png";